import React from 'react'

type alertContextualClass = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';

interface AlertProps {
  onDismiss?: () => void;
  contextualClass?: alertContextualClass;
}

export const Alert: React.FC<AlertProps> = ({ children, onDismiss, contextualClass }) =>
  <div className={`alert alert-${contextualClass || 'info'}`}>
    {children}
    {onDismiss && <button type="button" className="close" onClick={onDismiss}>&times;</button>}
  </div>
